import { Reveal } from "./Reveal";
import { SERVICES } from "@/data/content";

export const Services = () => (
  <section id="tjanster" className="scroll-mt-24 bg-white">
    <div className="mx-auto max-w-6xl px-6 py-24 md:py-32 lg:px-8">
      <Reveal>
        <p className="eyebrow">
          <span className="ic-triangle" aria-hidden="true" />
          Tjänster
        </p>
        <h2 className="mt-7 max-w-3xl font-display text-3xl font-normal leading-[1.1] tracking-[-0.01em] text-brand-ink md:text-5xl">
          Specialister på identitet och åtkomst
        </h2>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-brand-muted">
          IC Identity hjälper organisationer genom hela IAM-resan – från analys och strategi till
          implementation och långsiktig förvaltning.
        </p>
      </Reveal>

      <div className="mt-16 border-t border-brand-line md:mt-20">
        {SERVICES.map((service, i) => (
          <Reveal key={service.number} delay={i * 0.04}>
            <article className="group grid grid-cols-1 gap-5 border-b border-brand-line py-10 md:grid-cols-12 md:gap-8 md:py-16">
              <div className="md:col-span-2">
                <span className="font-display text-4xl font-light leading-none text-brand-ink/25 transition-colors duration-300 group-hover:text-brand-blue md:text-6xl">
                  {service.number}
                </span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display text-2xl font-medium text-brand-ink md:text-3xl">
                  {service.title}
                </h3>
                <p className="mt-3 font-medium text-brand-blue">{service.lead}</p>
              </div>
              <div className="md:col-span-6">
                {service.body.map((para, idx) => (
                  <p key={idx} className="mb-4 leading-relaxed text-brand-muted last:mb-0">
                    {para}
                  </p>
                ))}
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
